import React from 'react';
import { useArchivalAids } from './ctx-utils';
import { useEadTreeContext } from './EadTreeCtx';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import AidItem from './AidItem';
import { useAidsListByOriginator } from './fetch-with-cache';
import { Loader } from 'components/loader/loader';
import OriginatorFilterActive from './originator-filter-active';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    originatorWrapper: {
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontWeight: 'bold',
      fontSize: 16,
      padding: '16px',
    },

    originatorCategoryItemsWrapper: {
      padding: '0 24px',
    },
    originatorCategoryLabel: {
      fontSize: 15,
      marginBottom: -8,
    },
    gridTitle: {
      backgroundColor: theme.palette.secondary.main,
      color: 'white',
      fontWeight: 'bold',
      fontSize: 18,
      height: 60,
      lineHeight: '60px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      zIndex: 1000,
      position: 'sticky',
      top: 0,
      padding: '0 16px',
      width: '100%',
    },
    link: {
      color: theme.palette.grey[300],
    },
    listItem: {
      fontSize: 13,
      lineHeight: '1.5em',
      fontWeight: 500,
      color: theme.palette.grey[300],
    },
    listItemActive: {
      fontSize: 13,
      lineHeight: '1.5em',
      fontWeight: 500,
      color: theme.palette.primary.light,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    subTitle: {
      fontSize: 12,
      lineHeight: 'normal',
      textTransform: 'uppercase',
      fontWeight: 600,
      letterSpacing: '1px',
      color: theme.palette.grey[300],
    },
  })
);

const AidsList = () => {
  const { aids } = useArchivalAids();
  const classes = useStyles();
  const { originatorFilter } = useEadTreeContext();
  const response = useAidsListByOriginator(originatorFilter?.originator.id);

  if (response.isLoading) {
    return <Loader />;
  }
  const categories = response.data ?? {};

  return (
    <div>
      <div className={classes.gridTitle}>Pomůcky</div>
      <OriginatorFilterActive />
      {originatorFilter ? (
        <>
          {Object.keys(categories).map((key, index) => {
            const aids = categories[key];
            if (aids.length === 0) {
              return <></>;
            }
            return (
              <div key={`${key}-${index}`}>
                <div className={classes.originatorWrapper}>
                  <span className={classes.originatorCategoryLabel}>{key}</span>
                </div>
                <div className={classes.originatorCategoryItemsWrapper}>
                  {aids.map((aid) => (
                    <AidItem key={aid.id} aid={aid} level={0} />
                  ))}
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div style={{ padding: '0 16px' }}>
          {aids.map((aid) => (
            <AidItem key={aid.id} aid={aid} level={0} />
          ))}
        </div>
      )}
    </div>
  );
};

export default AidsList;
